export enum ChildCoefficientType {
    FACESHAPE,
    SKINTONE,
    EYECOLOR,
    HAIRCOLOR
}